import { render } from "./AdminClientList.vue?vue&type=template&id=030ec6da&scoped=true"
import script from "./AdminClientList.vue?vue&type=script&lang=js"
export * from "./AdminClientList.vue?vue&type=script&lang=js"

import "./AdminClientList.vue?vue&type=style&index=0&id=030ec6da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030ec6da"]])

export default __exports__